import styled from 'styled-components';
import { ThemeType } from '../../../types/Theme';

export const OrdenacaoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 2rem;
`;

export const SectionTitle = styled.div<{ theme: ThemeType }>`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.tertiary};
  margin-bottom: 1rem;
`;

export const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 350px;
  gap: 1rem;
`;

export const Chip = styled.button<{ theme: ThemeType; selected: boolean }>`
  padding: 0.8rem 1.6rem;
  border-radius: 50px;
  border: 2px solid ${({ theme, selected }) =>
    selected ? theme.colors.primary : theme.colors.elements};
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.primary : 'transparent'};
  color: ${({ theme, selected }) =>
    selected ? theme.colors.white : theme.colors.tertiary};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-size: 14px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme, selected }) =>
      selected ? theme.colors.primary : 'transparent'};
  }
`;

export const OrdenacaoHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 7rem;
  padding-bottom: 4rem;
  margin-bottom: 1rem;
    text-wrap: nowrap;
  width: 100%;
    @media (max-width: 440px) {
        justify-content: center;
        padding-right: 0;
    }
  @media print {
    display: none;
  }
`;
